import { Armchair, Coffee, Hourglass, Music } from "lucide-react";
import { Reveal } from "./Reveal";
import { Section } from "./Section";

const CARDS = [
  {
    icon: Armchair,
    title: "A Room With Character",
    text: "Vintage finds, warm lamps and art on the walls — a space that asks you to settle in, not pass through.",
  },
  {
    icon: Coffee,
    title: "Poured With Care",
    text: "Coffee and comfort drinks made slowly, the way an unhurried evening deserves.",
  },
  {
    icon: Hourglass,
    title: "Your Table, Your Pace",
    text: "Stay for a second cup, a long conversation or a quiet page. Nobody is watching the clock.",
  },
  {
    icon: Music,
    title: "Sound & Evenings",
    text: "A soft soundtrack of classics — and gatherings in the works, announced on Instagram first.",
  },
];

export const Experience = () => (
  <Section
    id="experience"
    eyebrow="The Experience"
    title="More than a meal"
    intro="Roma's is built around the things that turn a table into an evening."
  >
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {CARDS.map((card, i) => (
        <Reveal key={card.title} delay={i * 0.1}>
          <article
            data-testid={`experience-card-${card.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="card-surface group h-full p-7 transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-2 hover:border-[#d4af37]/40 hover:shadow-[0_16px_40px_rgba(0,0,0,0.5)]"
          >
            <div className="mb-6 inline-flex rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 p-3.5 text-[#d4af37] transition-transform duration-500 group-hover:scale-110">
              <card.icon size={22} aria-hidden="true" />
            </div>
            <h3 className="font-display text-xl font-semibold text-[#f7f4ef]">{card.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#b5afa7]">{card.text}</p>
          </article>
        </Reveal>
      ))}
    </div>
  </Section>
);
